// db.js
import { openDB } from 'idb'

export const getDB = () =>
  openDB('gep-file-cache-db', 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains('files')) {
        db.createObjectStore('files')
      }
    },
  })
